import { API_URL } from "./api";
import { GarageProfile } from "../types";

export const fetchGarageProfile = async (): Promise<GarageProfile | null> => {
  try {
    const res = await fetch(`${API_URL}/garage/profile`, {
      credentials: "include",
    });
    if (!res.ok) return null;
    const payload = await res.json();
    return payload.profile || null;
  } catch (e) {
    console.error("fetchGarageProfile failed", e);
    return null;
  }
};

export const saveGarageProfileRemote = async (profile: GarageProfile): Promise<void> => {
  try {
    await fetch(`${API_URL}/garage/profile`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(profile),
    });
  } catch (e) {
    console.error("saveGarageProfile failed", e);
  }
};
